/*
 * @Description: copy from webapp
 * @Author: kadenwang@tencent.com
 * @Date: 2020-06-18 17:27:57
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2021-09-02 19:21:18
 */

enum State {
  BeginDownload = '开始下载',
  Downloading = '下载中',
  DownloadPause = '已暂停',
  Installing = '安装中',
  Installed = '已安装',
  EndDownload = '下载完成',
  WaitForDownload = '等待下载',
  CanUpgrade = '可升级',
  CanInstall = '可安装',
  Uninstalling = '卸载中',
  EndUninstall = '已卸载',
  UpdateConfig = '更新配置中',
  init = '初始化',
  EngineStart = '引擎开始下载',
  EngineInstalling = '引擎安装中',
  EngineDownLoading = '引擎下载中',
  EngineFinish = '引擎安装完成',
  EngineDownloadFinish = '引擎下载完成',
  EngineError = '引擎下载失败',
  EngineDownloadPause = '引擎下载暂停',
  ConfigUpdateBegin = '更新配置开始',
  ConfigUpdateEnd = '配置更新结束',
  DownloadFailed = '下载失败',
  WaitPrePare = '准备中',
  CompareMD5 = '校验文件中',
  LocalInstallPathError = '本地安装文件不存在',
}

const gameState = {
  /**  GetInstalledList */
  NotInstall: 0, // 未安装
  Downloading: 1, // 下载中
  DownloadPause: 2, // 下载暂停
  Downloaded: 3, // 下载完成
  Installing: 4, // 安装中
  InstallPause: 5, // 安装暂停
  Installed: 6, // 已安装
  Running: 7, // 运行中

  WaitForDownload: 10, // 等待下载
  UpdateConfig: 14, // 正在更新配置
  CanUpgrade: 99, // web端自定义状态值，用于更新
};
const installState = {
  /** PkgStateChange */
  BeginDownload: 0, // 开始下载
  EndDownload: 1, // 下载完成
  BeginInstall: 2, // 开始安装
  EndInstall: 3, // 安装完成
  BeginUninstall: 4, // 卸载开始
  EndUninstall: 5, // 卸载结束
  PauseInstall: 6, // 暂停下载
  ContinueDownload: 7, // 继续下载
  WaitForDownload: 10, // 等待下载
  UpdateConfig: 14, // 正在更新配置 (时机: 开始下组件前， 开始下APK前)
  CancelUpdate: 15, // 取消更新
  CompareMD5: 16, // 校验MD5 (时机: 下组件前对当前已有的cache做MD5校验(引擎)，每下载完一个组件之后会做校验, apk同理)
  ConfigUpdateBegin: 17, // 更新配置开始 hubin状态
  ConfigUpdateEnd: 18, // 配置更新结束 hubin状态
  PauseLocalApkStart: 19,
};

// 由于历史原因有两种状态，一种installState是安装时客户端传进来的状态值， 另外一种gameState是页面进来时， 调用客户端的已安装接口传回来的游戏状态值， 把这两种合并成为一种
function getInstallState(params) {
  let result = State.CanInstall;
  const { state, error = 0, status } = params;
  if (state == null && status === null) {
    return State.CanInstall;
  }

  const mergeState = state || status || 0;

  if (error === 0) {
    switch (+mergeState) {
      case installState.BeginDownload:
      case installState.ContinueDownload:
        result = State.Downloading;
        break;
      case installState.EndDownload:
        result = State.EndDownload;
        break;
      case installState.BeginInstall:
        result = State.Installing;
        // if (+error === 0) {
        //   result = State.Installing;
        // } else {
        //   result = State.DownloadPause;
        // }

        break;
      case installState.BeginUninstall:
        result = State.Uninstalling;
        break;
      case installState.EndInstall:
        result = State.Installed;
        // if (+error === 0) {
        //   result = State.Installed;
        // } else {
        //   result = State.DownloadPause;
        // }

        break;
      case installState.PauseInstall:
        result = State.DownloadPause;
        break;
      case installState.WaitForDownload:
        result = State.WaitForDownload;
        break;
      case installState.UpdateConfig:
        result = State.UpdateConfig;
        break;
      case installState.CancelUpdate:
        result = State.CanUpgrade;
        break;
      case installState.ConfigUpdateBegin:
        result = State.ConfigUpdateBegin;
        break;
      case installState.ConfigUpdateEnd:
        result = State.ConfigUpdateEnd;
        break;
      case installState.EndUninstall:
        result = State.EndUninstall;
        break;
      case installState.CompareMD5:
        result = State.CompareMD5;
        break;
      default:
        break;
    }
  } else if (+mergeState === installState.EndInstall && +error === 4) {
    /** 用户主动中断安装 展示暂停就好 * */
    result = State.DownloadPause;
  } else if (error === 6) {
    result = State.LocalInstallPathError;
  } else {
    result = State.DownloadFailed;
  }

  return result;
}

function getGameState(params) {
  let result = State.CanInstall;
  const { state, status } = params;
  if (state == null && status === null) {
    return result;
  }

  const mergeState = state || status || 0;

  switch (mergeState) {
    case gameState.Downloading:
      result = State.Downloading;
      break;
    case gameState.NotInstall:
      result = State.init;
      break;
    case gameState.DownloadPause:
    case gameState.InstallPause:
      result = State.DownloadPause;
      break;
    case gameState.Downloaded:
      result = State.EndDownload;
      break;
    case gameState.Installing:
      result = State.Installing;
      break;
    case gameState.WaitForDownload:
      result = State.WaitForDownload;
      break;
    case gameState.Installed:
      result = State.Installed;
      break;
    case gameState.UpdateConfig:
      result = State.UpdateConfig;
      break;
    case gameState.CanUpgrade:
      result = State.CanUpgrade;
      break;
    default:
      break;
  }

  return result;
}

export {
  State,
  getInstallState,
  getGameState,
  gameState,
  installState,
};
